import * as _ from 'lodash';
import { Injectable } from '@angular/core';

import { PageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { _LevelGlobalPageService } from 'src/app/infrastructure/services/page-services/_level-global-page.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { TRouteCreate } from 'src/app/infrastructure/services/route-service/models/route-create';

@Injectable({
    providedIn: 'root'
})
export class AdminPageService
    extends _LevelGlobalPageService
{
    constructor() {
        super(
            null,
        )
    }

    override pageCreate_goto(): void {
        throw new Error('Method not implemented.');
    }

    override pageRoute_goto(): void {
        this.page_goto(routePage.adminPanel);
    }

}
